import React, { useState, useEffect } from "react";
import {NameInput} from "../components/NameInput";
import {DateInput} from "../components/DateInput";
import {GenreInput} from "../components/GenreInput";
import {PhoneInput} from "../components/PhoneInput";
import {EmailInput} from "../components/EmailInput";
import Card from "../components/Card";

const cardsImages = {
    0: "https://astrologyytoday2024.com/images/c-0.jpeg",
    1: "https://astrologyytoday2024.com/images/c-1.jpeg",
    2: "https://astrologyytoday2024.com/images/c-2.jpeg",
    3: "https://astrologyytoday2024.com/images/c-3.jpeg",
    4: "https://astrologyytoday2024.com/images/c-4.jpeg",
    5: "https://astrologyytoday2024.com/images/c-5.jpeg",
    6: "https://astrologyytoday2024.com/images/c-6.jpeg",
    7: "https://astrologyytoday2024.com/images/c-7.jpeg",
    8: "https://astrologyytoday2024.com/images/c-8.jpeg",
    9: "https://astrologyytoday2024.com/images/c-9.jpeg",
    10: "https://astrologyytoday2024.com/images/c-10.jpeg",
    11: "https://astrologyytoday2024.com/images/c-11.jpeg",
    12: "https://astrologyytoday2024.com/images/c-12.jpeg",
    13: "https://astrologyytoday2024.com/images/c-13.jpeg",
    14: "https://astrologyytoday2024.com/images/c-14.jpeg",
    15: "https://astrologyytoday2024.com/images/c-15.jpeg",
    16: "https://astrologyytoday2024.com/images/c-16.jpeg",
    17: "https://astrologyytoday2024.com/images/c-17.jpeg",
    18: "https://astrologyytoday2024.com/images/c-18.jpeg",
    19: "https://astrologyytoday2024.com/images/c-19.jpeg",
    20: "https://astrologyytoday2024.com/images/c-20.jpeg",
};

const Home = () => {
    const [cardClicked, setCardClicked] = useState(false);
    const [name, setName] = useState("");
    const [date, setDate] = useState("");
    const [genre, setGenre] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [steps, setSteps] = useState(0);
    const [flippedCards, setFlippedCards] = useState([]);
    const [transitionState, setTransitionState] = useState(false);
    const [conditions, setConditions] = useState({cguAgreed: false, consentAgreed: false});
    const [success, setSuccess] = useState(false);

    const handleCardClick = (cardId) => {
        if (flippedCards.includes(cardId)) {
            return;
        }
        setFlippedCards([...flippedCards, cardId]);
        setCardClicked(true);
        setSteps(steps + 1);
        setTransitionState(false);
    }

    useEffect(() => {
        const handleKeyPress = (event) => {
            if (event.key === "Enter") {
                handleNextCard();
            }
        }

        window.addEventListener("keydown", handleKeyPress);

        return () => {
            window.removeEventListener("keydown", handleKeyPress);
        }
    }, [name, date, genre, phone, email, steps]);

    const handleNextCard = () => {
        if (name === "" && steps === 1) {
            alert("Veuillez entrer votre prénom");
            return;
        } else if (date === "" && steps === 2) {
            alert("Veuillez entrer votre date de naissance");
            return;
        } else if (genre === "" && steps === 3) {
            alert("Veuillez choisir votre genre");
            return;
        } else if (phone === "" && steps === 4) {
            alert("Veuillez entrer votre numéro de téléphone");
            return;
        } else if (steps === 5) {
            console.log("final submit");
            handleFinalSubmit();
            return;
        }
        setTransitionState(true);
        setCardClicked(false);
    }

    const handleFinalSubmit = () => {
        if (email === "") {
            alert("Veuillez entrer votre adresse email");
            return;
        }
        if (!email.includes("@") || !email.includes(".")) {
            alert("Veuillez entrer une adresse email valide");
            return;
        }

        const makeRequest = (url) => {
            return new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();
                xhr.open("POST", url, true);
                xhr.onreadystatechange = function() {
                    if (xhr.readyState === 4) {
                        if (xhr.status === 200) {
                            console.log(xhr.responseText);
                            resolve();
                        } else {
                            console.log("Error", xhr.statusText);
                            reject(new Error("Une erreur est survenue, veuillez réessayer plus tard"));
                        }
                    }
                };
                xhr.send();
            });
        };

        conditions.cguAgreed = conditions.cguAgreed ? "oui" : "non";
        conditions.consentAgreed = conditions.consentAgreed ? "oui" : "non";
        const url = `https://www.irina-voyance.fr/atrail.php?query=saveDB&track=LP1&name=${name}&partner=undefined&birth=${date}&quinevapas=undefined&emailName=${email}&question=undefined&general=undefined&gender=${genre}&phoneName=${phone}`;
        const url2 = `https://www.irina-voyance.fr/insert.php?query=saveDB&track=LP1&name=${name}&partner=undefined&birth=${date}&quinevapas=undefined&emailName=${email}&question=undefined&general=undefined&gender=${genre}&phoneName=${phone}&cguAgreed=${conditions.cguAgreed}&consentAgreed=${conditions.consentAgreed}`;
        makeRequest(url)
            .then(() => makeRequest(url2))
            .then(() => {
                window.location.href = "/LP1/thankyou"
                console.log("Success");
            })
            .catch((error) => {
                alert(error.message);
            });
        setSuccess(true);
    }

    const renderStepContent = () => {
        if (transitionState) {
            console.log("Transition state");
            return <div className={"content"}>
                <h1 className={"big-description"}>Sélectionnez une nouvelle carte, préparez-vous à l'émerveillement !</h1>
                <p className={"small-description"}>Partagez avec moi votre histoire amoureuse, plongez-moi dans les détails captivants!</p>
            </div>
        }
        switch (steps) {
            case 1:
                return <NameInput name={name} setName={setName} />;
            case 2:
                return <DateInput date={date} setDate={setDate} />;
            case 3:
                return <GenreInput genre={genre} setGenre={setGenre} />;
            case 4:
                return <PhoneInput phone={phone} setPhone={setPhone} />;
            case 5:
                return <EmailInput email={email} setEmail={setEmail} handleFinalSubmit={handleFinalSubmit} checkboxStates={conditions} setCheckboxStates={setConditions} />;
            default:
                return <div className={"content"}>
                    <h1 className={"big-description"}>Sélectionnez une nouvelle carte, préparez-vous à l'émerveillement !</h1>
                    <p className={"small-description"}>Partagez avec moi votre histoire amoureuse, plongez-moi dans les détails captivants!</p>
                </div>;
        }
    }

    function getCardImage() {
        return cardsImages[Math.floor(Math.random() * 20)];
    }

    return (
        <>
            <div className={"header"}>
                <img className="header-image" src={require("../assets/irina_pp.png")} alt="logo" />
                <div className={"header-text"}>
                    <h1 className="header-title">Irina</h1>
                    <h3 className="header-subtitle">La voyante préférée des Stars</h3>
                </div>
            </div>
            {steps !== 0 ? (
                <>
                    {renderStepContent()}
                    {cardClicked && steps !== 5 ? (
                        <>
                            <button className={"button"} onClick={handleNextCard}>CARTE SUIVANTE</button>
                        </>
                    ) : (
                        <>
                        </>
                    )}
                </>
            ) : (
                <>
                    <div className="content">
                        <h1 className="big-description">
                            Bienvenue, âmes lumineuses. Je suis Irina, prête à éclairer votre trajectoire céleste.
                        </h1>
                        <p className="small-description">
                            Permettez-moi de vous dévoiler les secrets de votre destin. Prenez une carte, elle révélera les énigmes qui habitent votre esprit.
                        </p>
                    </div>
                </>
            )}
            <div className="cards">
                {[...Array(6)].map((_, index) => (
                    <Card
                        key={index}
                        id={index}
                        image={getCardImage()}
                        onClick={() => handleCardClick(index)}
                        disableClick={cardClicked || flippedCards.includes(index)}
                        higher={index % 2 === 0}
                    />
                ))}
            </div>
            <footer className={"footer"}>
                {steps === 4 && !transitionState && (
                    <p className={"footer-text"}>(1) L'accès à cette offre commerciale est soumis aux conditions suivantes: 10 minutes de voyance privée offertes. Offre valable dans la limite des 10 premières minutes, après validation de votre compte client comprenant votre nom, prénom, téléphone, email et carte de paiement valide. Au-delà des 10 premières minutes, le tarif est de 3.50EUR à 9.50EUR la minute supplémentaire selon le voyant. Offre limitée à la première voyance par compte client.
                        Vous nous communiquez votre numéro de téléphone afin de profiter de cette offre et, si vous ne répondez pas à notre premier rappel gratuit, nous tenterons de vous rappeler dans les 4 heures (y compris dimanche et jours fériés si votre demande avait lieu ces jours-ci). Si vous ne souhaitez pas être rappelé, ne renseignez pas le formulaire et sachez que vous pouvez vous inscrire sur une liste d'opposition au démarchage téléphonique tenue par OPPOSETEL en vous rendant sur le site www.bloctel.gouv.fr
                        ; cette inscription est toutefois inopérante si vous êtes déjà membre du Site ou des Partenaires.</p>
                )}
                {steps === 5 && !transitionState && (
                    <p className={"footer-text"}>(2) Ce consentement exprès s'applique à la société Cosmospace et les sociétés Telelemaque, Pluton Media et Cassipée afin de recevoir leurs offres de voyance. Par téléphone, il est entendu toutes émissions d'appel émanant de la société Cosmospace et des sociétés Telemaque, Pluton Media et Cassiopée afin de recevoir, comme consenyies, leurs offres de voyance dans le respect des règlementations en vigueur. Par voie électronique, il est entendu toute communication par email, sms et voie IP.</p>

                )}
                <p className={"footer-text"}>© 2021 Irina Voyance | <a className="legal-mentions" href={"https://www.voyance.fm/cgu/"}>mentions légales</a></p>
            </footer>
        </>
    );
}

export default Home;